import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import {
  AtlasPost,
  AtlasPostImage,
  AtlasPostImagePage,
  AtlasPostListQuery,
  AtlasPostPage,
  AtlasPostWrite
} from './model/atlasPosts'

const url = () =>
  `${getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)}/api/Atlas`

export const getPosts = async (query: AtlasPostListQuery): Promise<AtlasPostPage> =>
  (await AxiosInstance.get<AtlasPostPage>(`${url()}/GetPostsAtlas`, { params: query })).data

export const getPost = async (postAtlasId: number): Promise<AtlasPost> =>
  (await AxiosInstance.get<AtlasPost>(`${url()}/GetPostAtlas`, { params: { postAtlasId } })).data

export const createPost = async (post: AtlasPostWrite): Promise<AtlasPost> =>
  (await AxiosInstance.post<AtlasPost>(`${url()}/CreatePostAtlas`, post)).data

export const replacePost = async (postAtlasId: number, post: AtlasPostWrite): Promise<void> => {
  await AxiosInstance.put(`${url()}/ReplacePostAtlas`, post, { params: { postAtlasId } })
}

export const publishPost = async (postAtlasId: number, fechaPublicacion: string): Promise<void> => {
  await AxiosInstance.patch(
    `${url()}/PublishPostAtlas`,
    { fechaPublicacion },
    { params: { postAtlasId } }
  )
}

export const archivePost = async (postAtlasId: number): Promise<void> => {
  await AxiosInstance.patch(`${url()}/ArchivePostAtlas`, null, { params: { postAtlasId } })
}

export const deletePost = async (postAtlasId: number): Promise<void> => {
  await AxiosInstance.delete(`${url()}/DeletePostAtlas`, { params: { postAtlasId } })
}

export const uploadImage = async (file: File): Promise<AtlasPostImage> => {
  const form = new FormData()
  form.append('file', file)
  return (await AxiosInstance.post<AtlasPostImage>(`${url()}/UploadPostAtlasImage`, form)).data
}

export const getImages = async (page = 1, pageSize = 20): Promise<AtlasPostImagePage> =>
  (await AxiosInstance.get<AtlasPostImagePage>(`${url()}/GetPostAtlasImages`, {
    params: { page, pageSize }
  })).data
